export var LegacyPhoneNumberAdaptor = function(phoneType, phoneNumberData) {
    var phoneNumber = {};
    
    // Constructor
    if (phoneNumberData) {
        phoneNumber.country = phoneNumberData.country;
        phoneNumber.type = phoneType;
        phoneNumber.value = phoneNumberData.value;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return phoneNumber;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyPhoneNumberAdaptor.js
// module id = 198
// module chunks = 0